export default [
	'txtTitle',
	'txtDescription',
	'dtStartDate',
	'dtEndDate',
	'cmbAssignCategory',
	'cmbAssign',
	'cmbState',
	'tbTags',
	'nbActionId',
	'nbPriority',
	'RDMedia'
];
